import { Component, Input, OnInit } from '@angular/core';
import { WizardService } from '@shared/services/wizard.service';
import { CommonModule, Location } from '@angular/common';
import { NavigationService } from '@shared/services/navigation.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss'],
  imports: [TranslateModule, CommonModule],
})
export class WizardComponent implements OnInit {

  @Input() config: any;
  @Input() showTitles = false;
  component: Component;

  constructor(
    public wizardService: WizardService,
    private navigation: NavigationService

  ) { }

  ngOnInit() {
    this.wizardService.steps = this.config;
    this.wizardService.current = 0;
  }

  get steps() {
    return this.wizardService.steps;
  }

  get current() {
    return this.wizardService.currentStep;
  }

  nextStep() {
    this.wizardService.nextStep();
  }

  previousStep() {
    this.wizardService.previousStep();
  }

  cancel() {
    this.navigation.back();
  }

  get hasAnyAction(): boolean {
    return this.current.previousStepEnabled || this.current.cancelStepEnabled || this.current.nextStepShow;
  }

}
